import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, BriefcaseIcon, GavelIcon, HeartPulseIcon, MonitorSmartphoneIcon, UsersIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { expertise } from '../data/site';
const icons = [ActivityIcon, BriefcaseIcon, GavelIcon, HeartPulseIcon, MonitorSmartphoneIcon, UsersIcon];
export function Expertise() {
  return <>
      <PageHeader eyebrow="Core Expertise" title="Where clinical depth meets investment discipline." description="Six domains of operating experience applied across health systems, health plans, venture portfolios, and growth-stage companies." data-id="element-159" data-mp="1bnya19nfjshd" />

      <section className="w-full bg-ivory py-20 lg:py-24" data-id="element-160" data-mp="1qkp5x8xwam28">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-161" data-mp="2wzq3tk6hdebg">
          <div className="grid gap-px border border-stone bg-stone sm:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="2wz84ufsfolzu">
          {expertise.map((item, i) => {
            const Icon = icons[i];
            return <motion.article key={item.title} initial={{
              opacity: 0,
              y: 14
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.4,
              delay: i % 3 * 0.08
            }} className="group bg-white p-8 transition-colors hover:bg-ink-950 lg:p-10" data-id="element-163" data-mp="1x5qqo4znpxqt" data-mpi={i}>
                <Icon size={22} className="text-brass-500" aria-hidden="true" data-id="element-164" data-mp="1e8z6zug7dgm8" />
                <h2 className="mt-6 font-display text-base leading-snug text-ink-950 transition-colors group-hover:text-ivory" data-id="element-165" data-mp="14hblea6butso">
                  {item.title}
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-graphite transition-colors group-hover:text-slate-300" data-id="element-166" data-mp="10e6mehlgha8s">
                  {item.body}
                </p>
              </motion.article>;
          })}
          </div>
        </div>
      </section>
    </>;
}